import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import React, { useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import OnScrollLoading, { handleScroll } from '../OnScrollLoading';
import { SbDownloadBtn } from '../SbButtons/SbAddBtn';
// import SkeletonTableData from '../Skeleton Loading/SkeletonTableData';

function CustomerTable(props) {
    const lastItemSerialNumber = props.getCustomers.length > 0
        ? (props.getCustomers.length)
        : 0;
    return (
        <div className="sb-table-div sb-table-setion">
            <Paper
                sx={{ width: "100%", overflow: "hidden" }}
                className="table-main-div"
            >
                <TableContainer
                    sx={{ maxHeight: 440 }}
                    onScroll={(e) =>
                        handleScroll(
                            e,
                            props.fetchData,
                            props.isLoading,
                            props.setLoading,
                            props.setOffset,
                            props.offset,
                            props.PageSize,
                            props.hasMoreData
                        )
                    }
                >
                    <Table
                        stickyHeader
                        aria-label="sticky table table-responsive"
                        className="client-table"
                    >
                        <TableHead className="custom-table-header">
                            <TableRow>
                                {props.tableHeader.map((name, i) => (
                                    < TableCell key={i} align={name.align} className={`thead-cell-products`}
                                        style={{ minWidth: name.width }}>
                                        {name.name}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        {props.isLoading ? (
                            <>
                                {/* {props.tableHeader.map((header, i) => (
                  <SkeletonClients key={i} />
                ))} */}
                            </>
                        ) : (
                            <>
                                {props.getCustomers && props.getCustomers.length === 0 ? (
                                    <TableBody>
                                        <TableRow>
                                            <TableCell
                                                align="center"
                                                colSpan={props.tableHeader.length}
                                            >
                                                --- NO DATA FOUND ---
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                ) : (
                                    <TableBody>
                                        {props.getCustomers.map((data, i) => (
                                            <TableRow
                                                align="center"
                                                key={i}
                                                className="client-list-row-data"
                                            >
                                                <TableCell>
                                                    <div className="users-list-name">
                                                        <div>
                                                            <img
                                                                className="table-data-users-imgages company-logo"
                                                                src={`https://accounts.metricinfo.com/static/media/Default_company.1b81cea453b5127f3cae.jpg`}
                                                                alt="client-profile"
                                                            />
                                                        </div>
                                                        <div>
                                                            {/* <div
                                                                className="table-row-head-Text"
                                                            >
                                                                <strong> #{data?.customerid}</strong>
                                                            </div> */}

                                                            <div className="table-row-sub-text">
                                                                <span>{data?.companyname}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </TableCell>
                                                <TableCell>
                                                    {data.contactperson}
                                                </TableCell>
                                                <TableCell>
                                                    <span className="color-green">{data?.contactphone}</span>{" "}
                                                    <br />
                                                    <span>{data?.contactemail}</span>
                                                </TableCell>
                                                <TableCell>
                                                    {data.businesstype}
                                                </TableCell>
                                                <TableCell>
                                                    {data.country}
                                                </TableCell>
                                                <TableCell>
                                                    {data.state}
                                                </TableCell>
                                                <TableCell>
                                                    {data.city}
                                                </TableCell>
                                                <TableCell>
                                                    {data?.status === "Active" ? (
                                                        <span className="status-badge complete-status">Active</span>
                                                    ) : (
                                                        <span className="status-badge cancel-status">InActive</span>
                                                    )}
                                                </TableCell>
                                                <TableCell>
                                                    <span className="user-action-td" onClick={() => props.handleEdit(data.customerid)}>
                                                        <Link className="user-edit-link">
                                                            <i className="fa fa-edit"></i> Edit
                                                        </Link>
                                                    </span>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                )}
                            </>
                        )}
                    </Table>
                </TableContainer>
                {props.loading && <OnScrollLoading />}
                <div className="user-table">
                    {/* PAGINATION START */}
                    <div className="download-and-pagination">
                        <SbDownloadBtn
                            btnName="Download"
                            onClickEffect={props.exportCustomerDetails}
                            offset={lastItemSerialNumber}
                        />
                    </div>
                    {/* PAGINATION END */}
                </div>
            </Paper>
        </div>
    )
}

export default CustomerTable;
